export default {
  name: '添易',

  // 生产环境
  requestUrl: 'https://ylyad.com/api',

  // 开发环境
  // requestUrl: 'http://localhost:58080/',

  packagePath: '',
  minWidth: 1300,
  header: {
    nameText: {
      ssp: '媒体变现',
      dsp: '广告投放',
      ads: '广告样式',
      more: '更多产品'
    },
    buttonText: '免费试用'
  },
  banner: {
    imgPath: 'assets/images/banner/',
    url: {
      ssp: 'http://www.yileyunssp.com/',
      dsp: 'http://dsp.yileyunssp.com/'
    },
    buttonText: '立即登录'
  },
  ssp: {
    titleText: '流量变现产品',
    imgPath: 'assets/images/ssp/',
    card: [
      {
        titleText: '广告聚合变现',
        contentText: [
          '快速灵活接入广告，广告库资源丰富，添易ADX接入自家DSP平台和今日头条穿山甲、百度百青藤、腾讯优量汇等头部DSP，助媒体获取更高价广告资源。',
          '提供专业级SSP管理系统，可动态配置广告资源，实时监测流量数据。'
        ],
        button: {
          text: '接入广告SDK',
          url: ''
        }
      },
      {
        titleText: '信息流聚合变现',
        contentText: [
          '提供浏览器、手机负一屏、锁屏资讯等场景信息流能力，支持定制资讯、视频、小视频、图片等丰富频道及信息流，内容覆盖众多领域。',
          '支持在内容中无缝嵌入原生广告，实现媒体高价值变现。'
        ],
        button: {
          text: '接入信息流SDK',
          url: ''
        }
      }
    ],
    describe: [
      {
        titleText: '高额收益回报',
        contentText: [
          '快速接入分发渠道，选择效益最佳的优质DSP，实现填充和收益最大化。',
          '为媒体智能优选价格更高的广告源， 精准人群定向，智能推荐最具收益潜力的广告，提升广告价值。'
        ],
        imgUrl: '1.png'
      },
      {
        titleText: '丰富的广告样式',
        contentText: [
          '支持多样化广告样式合作，以最友好的方式吸引用户，达到最优质的用户体验，提高推广效果。',
          '样式包括开屏广告、信息流广告、Banner广告、插屏广告、激励视频广告等。'
        ],
        imgUrl: '2.png'
      },
      {
        titleText: '海量广告资源',
        contentText: [
          '添易与海量优质广告主合作，覆盖游戏、电商、汽车、资讯等众多领域，确保广告拥有极高填充率。同时严格把控广告质量，保证广告的点击率，提高媒体收益。'
        ],
        imgUrl: '3.png'
      },
      {
        titleText: 'SSP广告管理',
        contentText: [
          '提供媒体方专属后台，全方位、多维度的数据报表透视，为媒体提供透明的流量和收入数据。',
          '支持自定义广告位、广告形式、地域时间、投放平台等配置，站式流量资源管理，避免流量浪费。',
          '支持信息流资讯管理，可配置资讯的广告库和资讯库内容，定制最匹配的频道和广告组合，助力信息流变现能力。'
        ],
        imgUrl: '4.png'
      }
    ]
  },
  dsp: {
    imgPath: 'assets/images/dsp/',
    describe: [
      {
        titleText: '优质媒体流量',
        contentText: [
          '平台不仅拥有自家信息流海量用户，同时合作经过严格审核筛选',
          '广告形式丰富，覆盖品类齐全，多维度触达用户场景，适合多种行业不同需求的推广，供您灵活选择最合适的媒体资源'
        ],
        imgUrl: '1.png'
      },
      {
        titleText: '精准定向投放',
        contentText: [
          '结合DMP数据源（自有数据、第三方数据合作），分析用户特征、地域、行为、兴趣、设备等数据，智能化构建用户画像，为您精准锁定目标人群，定向投放广告，降低成本提高广告效果'
        ],
        imgUrl: '2.png'
      },
      {
        titleText: '灵活计费模式',
        contentText: [
          '添易支持CPM、oCPM、CPC、CPD、CPT等计费方式，供广告主根据产品特性灵活选择推广模式，实现成本最优',
          '在获取优质流量的前提下，平台按照您的广告预算推广，实时监测广告数据，并根据广告效果灵活调控最佳配置，节约投放成本'
        ],
        imgUrl: '3.png'
      },
      {
        titleText: '效果数据监控',
        contentText: [
          '平台为广告主提供完善的推广后台，多维度组合实现投放时段、地域、媒体及广告素材、展现频次等交叉对比，辅助制定最优投放计划和策略',
          '时刻跟踪数据，提供多维度详细数据报表，一键检索每日详细曝光展示转化等数据，准确评估广告ROI'
        ],
        imgUrl: '4.png'
      }
    ]
  },
  ads: {
    imgPath: 'assets/images/ads/',
    describe: [
      {
        titleText: '信息流广告',
        contentText: [
          '作为应用内容的一部分与应用内容高度融合的广告样式',
          '展示场景：列表页、焦点图、文章详情页、视频详情页等',
          '优势：广告内容融入应用页面，浑然一体提升阅读体验，广告效果好'
        ],
        buttonText: [
          '小图',
          '大图',
          '组图',
          '视频'
        ],
        imgBackground: [
          'info_1_1.png',
          'info_2_1.png',
          'info_3_1.png',
          'info_4_1.png'
        ],
        imgUrl: [
          'info_1_2.jpg',
          'info_2_2.jpg',
          'info_3_2.jpg',
          'info_4_2.jpg'
        ]
      },
      {
        titleText: '开屏广告',
        contentText: [
          '应用开启后全屏展现的广告样式',
          '展现场景：应用开启时',
          '优势：全屏位置可点，点击率高，视觉效果震撼、辨识度高提升品牌价值渗透，激发用户记忆'
        ],
        imgUrl: [
          'open_1.png'
        ]
      },
      {
        titleText: 'Banner广告',
        contentText: [
          '应用开启后全屏展现的广告样式',
          '展现场景：用户停留较久的页面、访问频繁的页面',
          '优势：嵌入成本低、干扰小用户认可度高、最高曝光可见性'
        ],
        imgBackground: [
          'banner_1_1.png'
        ],
        imgUrl: [
          'banner_1_2.jpg'
        ]
      },
      {
        titleText: '插屏广告',
        contentText: [
          '应用暂停或场景切换时，以半屏或全屏的形式弹出',
          '展现场景：视频前贴/暂停/后贴、游戏过关/失败、阅读翻页/加载、应用退出等',
          '优势：视觉冲击强烈、交互场景丰富、减少对界面的占用'
        ],
        imgBackground: [
          'insert_1_1.png'
        ],
        imgUrl: [
          'insert_1_2.jpg'
        ]
      },
      {
        titleText: '激励视频广告',
        contentText: [
          '深度适配APP原生模式的15～30秒全屏视频广告',
          '展现场景：游戏、阅读、应用商店类场景',
          '优势：与内容场景完美结合、沉浸式用户体验、转化率高、变现能力超强'
        ],
        imgUrl: [
          'video_1.png'
        ]
      }
    ]
  },
  more: {
    imgPath: 'assets/images/more/',
    describe: [
      {
        titleText: '应用管理系统',
        contentText: [
          '为应用提供全面的参数配置功能，可根据不同产品特性灵活匹配策略，助力应用高效合理运行。',
          '可定制升级管理功能，可配置应用升级包和升级方式，支持全量升级或差分升级，同时可按渠道、版本、地域、设备等多维度组合更新。',
          '提供详尽数据报表，分析不同版本应用更新与用户情况，实时跟进新增及活跃用户，清晰展现数据波动效果，指导优化配置方案。'
        ],
        imgUrl: '1.png',
        loginUrl: 'http://appmgr.ylyapps.com/',
        // buttonText: '立即登录'
        buttonText: '申请试用'
      },
      {
        titleText: '客户CRM管理系统',
        contentText: [
          'CRM提供业务管理功能，支持代码位配置，并进行数据采集和分配审核，核对代码位下真实数据量。同时提供渠道分账管理，计算不同渠道及产品的分成数据。',
          '通过多图表展现分析广告业务数据，核实不同计费方式下每个时间节点的展示、点击、ECPM、收入等数据。'
        ],
        imgUrl: '2.png',
        loginUrl: 'http://crm.efunyun.com/ylycrm/#/login',
        // buttonText: '立即登录'
        buttonText: '申请试用'
      },
      {
        titleText: '销量统计系统',
        contentText: [
          '系统为智能终端和物联网设备等平台提供销量统计管理，支持按日、按月、按用户注册、用户活跃等多区间统计分析，可根据渠道、地域、时间段、品牌、机型、软件版本等维度筛选细分群体报表，精确的数据依据为平台决策提供保障。',
          '支持不同品牌区分统计，提供不同时间维度各品牌的数据汇总，直观对比各品牌销量表现，精确定位品牌销量差异，总结销售成果'
        ],
        imgUrl: '3.png',
        loginUrl: 'http://salesmanage.xnx01.com/salesweb/page/login.jsp',
        // buttonText: '立即登录'
        buttonText: '申请试用'
      }
    ]
  },
  partner: {
    titleText: '合作伙伴',
    imgPath: 'assets/images/partner/',
    imgUrl: [
      'baidu.jpg',
      'chuanshanjia.jpg',
      'xiaolajiao.jpg',
      'zhongxing.jpg',
      'youlianghui.jpg',
      'toutiao.jpg',
      'tangguo.jpg'
    ],
    speed: 20,
    distance: 10
  },
  contact: {
    requestUrl: '/contact/business',
    titleText: '联系商务',
    describeText: '请留下您的联系方式，我们会尽快与您联系！',
    demandText: '您的意向需求（多选）：',
    input: [
      {id: 'name', name: '姓名', must: true},
      {id: 'phoneNumber', name: '手机号', must: true, reg: /^1[3456789]\d{9}$/},
      {id: 'company', name: '公司名称', must: false},
      {id: 'qqEmail', name: 'QQ/邮箱', must: false}
    ],
    demand: [
      '流量变现',
      '广告投放',
      '应用管理系统',
      'CRM管理系统',
      '销量统计系统',
      '其他'
    ],
    demandKey: 'intentionalDemands',
    buttonText: '提交',
    mailText: '商务邮箱：bd@ylyad.com',
    success: {
      titleText: '提交成功',
      contentText: '我们的专业顾问将尽快通过电话联系您请您保持电话畅通！',
      buttonText: '知道了'
    }
  },
  footer: {
    infoText: '专业流量变现及广告投放平台',
    copyrightText: `Copyright © 2014-${new Date().getFullYear()} 深圳市易乐云科技有限公司 版权所有  `,
    copyrightCode: '粤ICP备17164067号',
    copyrightCodeUrl: 'http://beian.miit.gov.cn'
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/option.js